import React from "react";
import "./FAQ.css";

class FAQ extends React.Component {
  state = {
    collapseID: "collapse1",
  };

  toggleCollapse = (collapseID) => () =>
    this.setState((prevState) => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : "",
    }));

  render() {
    const { collapseID } = this.state;
    return (
      <div className="col" style={{ padding: "0px" }}>
        <div
          className="row"
          style={{
            paddingTop: "8vh",
            backgroundColor: "#34406B",
            textAlign: "center",
          }}
        >
          <p className="p_faq_titile">
            Preguntas <span className="span_faq_titile"> frecuentes</span>
          </p>
        </div>

        <div className="view-figure "></div>

        <div className="faq_background">
          <button
            type="button"
            class={
              collapseID === "collapse1"
                ? "faq_collapsible faq_active"
                : "faq_collapsible "
            }
            onClick={this.toggleCollapse("collapse1")}
          >
            ¿Cómo me registro?
          </button>
          <div
            class={
              collapseID === "collapse1" ? "faq_content_active" : "faq_content"
            }
          >
            <ol>
              <li> Descarga la app de la tienda de apps. </li>
              <li>
                Inicia sesión con tu respectiva cuenta de Google, Facebook o
                Apple.
              </li>
              <li> Llena los datos solicitados. </li>
              <li> Sube la documentación solicitada. </li>
              <li> Se parte de la comunidad de Tovo.</li>
            </ol>
          </div>

          <button
            type="button"
            class={
              collapseID === "collapse2"
                ? "faq_collapsible faq_active"
                : "faq_collapsible "
            }
            onClick={this.toggleCollapse("collapse2")}
          >
            ¿Para qué sirve la verificación de identidad?
          </button>
          <div
            class={
              collapseID === "collapse2" ? "faq_content_active" : "faq_content"
            }
          >
            <p>
              La verificación de la identidad de nuestros usuarios mediante el
              registro de la respectiva documentación, se realiza en favor de
              generar un ambiente seguro entre usuarios beneficiando tanto a
              conductores como pasajeros que usan la app.
            </p>
          </div>

          <button
            type="button"
            class={
              collapseID === "collapse3"
                ? "faq_collapsible faq_active"
                : "faq_collapsible "
            }
            onClick={this.toggleCollapse("collapse3")}
          >
            ¿Tovo permite viajes interprovinciales?
          </button>
          <div
            class={
              collapseID === "collapse3" ? "faq_content_active" : "faq_content"
            }
          >
            <p>
              El servicio de rutas compartidas de Tovo, cuenta con la
              posibilidad de realizar rutas interprovinciales. Dependiendo de la
              disponibilidad y aceptación del conductor.
            </p>
          </div>

          <button
            type="button"
            class={
              collapseID === "collapse4"
                ? "faq_collapsible faq_active"
                : "faq_collapsible "
            }
            onClick={this.toggleCollapse("collapse4")}
          >
            ¿Cuál es el límite de peso de las encomiendas?
          </button>
          <div
            class={
              collapseID === "collapse4" ? "faq_content_active" : "faq_content"
            }
          >
            <p>
              El peso máximo de encomiendas es determinado por el conductor.
            </p>
          </div>

          <button
            type="button"
            class={
              collapseID === "collapse5"
                ? "faq_collapsible faq_active"
                : "faq_collapsible "
            }
            onClick={this.toggleCollapse("collapse5")}
          >
            ¿Se cumplen con las normas de bioseguridad?
          </button>
          <div
            class={
              collapseID === "collapse5" ? "faq_content_active" : "faq_content"
            }
          >
            <p>
              Todos los conductores de la comunidad de Tovo cumplen con las
              respectivas normas de bioseguridad recomendadas por la OMS y
              entidades relacionadas.
            </p>
          </div>

          <button
            type="button"
            class={
              collapseID === "collapse6"
                ? "faq_collapsible faq_active"
                : "faq_collapsible "
            }
            onClick={this.toggleCollapse("collapse6")}
          >
            ¿Cómo ayuda Tovo al medio ambiente?
          </button>
          <div
            class={
              collapseID === "collapse6" ? "faq_content_active" : "faq_content"
            }
          >
            <p>
              Las rutas compartidas de Tovo, son una manera de reducir la
              producción de CO2 en las calles. Por cada uno de los viajes y
              dependiendo de la distancia de este, la cantidad de C02 ahorrada
              será mostrada al usuario en la pantalla de inicio de la aplicación
              móvil.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default FAQ;
